import { Routes } from '@angular/router';

import { LayoutBasicComponent } from '../layout';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../providers/auth.guard';
import { CanDeactivateGuard } from '../providers/can-deactivate.guard';
import { DashboardGuard } from '../providers/dashboard.guard';
import { AccountListComponent } from './account/list/account-list.component';
import { TenantDashboardComponent } from './dashboard/tenant-dashboard/tenant-dashboard.component';
import { FacebookCallbackComponent } from './facebook-callback/facebook-callback.component';
import { InstagramCallbackComponent } from './instagram-callback/instagram-callback.component';
import { IssueRepairDetailComponent } from './issue-repair/detail/issue-repair-detail.component';
import { IssueRepairListComponent } from './issue-repair/list/issue-repair-list.component';
import { LiteConsoleLoginAuthorizationComponent } from './liteconsole-login-authorization/liteconsole-login-authorization.component';
import { LogDetailComponent } from './log/detail/log-detail.component';
import { LogListComponent } from './log/list/log-list.component';
import { OfficialAssistantStoreComponent } from './official/assistant-store/official-assistant-store.component';
import { SocketioConnectionAuditComponent } from './official/socketio-connection-audit/socketio-connection-audit.component';
import { OfficialThirdPartyAppsComponent } from './official/third-party-apps/official-third-party-apps.component';
import { OnlineUsersComponent } from './online-users/online-users.component';
import { OrderPaymentResultComponent } from './payment-result/order-payment-result.component';
import { PointAuditCenterComponent } from './point-audit-center/point-audit-center.component';
import { PricingPackageCenterComponent } from './pricing-package-center/pricing-package-center.component';
import { QuotaTemplateComponent } from './quota/quota-template.component';
import { QuotaPlanComponent } from './quota-plan/quota-plan.component';
import { QuotaViewComponent } from './quota-view/quota-view.component';
import { ReportListComponent } from './report/list/report-list.component';
import { RobotServiceConfigComponent } from './robot-service/config/robot-service-config.component';
import { RobotServiceListComponent } from './robot-service/list/robot-service-list.component';
import { ScheduledTaskManagementComponent } from './scheduled-task-management/scheduled-task-management.component';
import { ServiceConfigComponent } from './servicenumber/detail/config/servicenumber-config.component';
import { SystemConfigComponent } from './system-config/system-config.component';
import { SystemappListComponent } from './systemapp/list/systemapp-list.component';
import { TeamCertificationAuditComponent } from './team-certification-audit/team-certification-audit.component';
import { TenantDetailComponent } from './tenant/detail/tenant-detail.component';
import { TenantListComponent } from './tenant/list/tenant-list.component';
import { PersonalAssistantManagementComponent } from './tenant/personal-assistant-management/personal-assistant-management.component';
import { PersonalBroadcastDetailComponent } from './tenant/personal-broadcast/detail/personal-broadcast-detail.component';
import { PersonalBroadcastListComponent } from './tenant/personal-broadcast/list/personal-broadcast-list.component';
import { PersonalBusinessCardSettingComponent } from './tenant/personal-business-card-setting/personal-business-card-setting.component';
import { PersonalInboundReasonCreateComponent } from './tenant/personal-inbound-reason/detail/personal-inbound-reason-create.component';
import { PersonalInboundReasonComponent } from './tenant/personal-inbound-reason/list/personal-inbound-reason.component';
import { PersonalRobotSettingComponent } from './tenant/personal-robot-setting/personal-robot-setting.component';
import { PersonalServiceSettingComponent } from './tenant/personal-service-setting/personal-service-setting.component';
import { PersonalChannelComponent } from './tenant/personal-tenant/personal-channel/personal-channel.component';
import { PersonalTenantComponent } from './tenant/personal-tenant/personal-tenant.component';
import { PersonalWebchatSettingComponent } from './tenant/personal-webchat-setting/personal-webchat-setting.component';
import { TenantApplicationListPageComponent } from './tenant/tenant-application-list-page.component';
import { TenantAuthenticationComponent } from './tenant/tenant-authentication/tenant-authentication.component';
import { TenantBasicInfoPageComponent } from './tenant/tenant-basic-info-page.component';
import { TenantConfigPageComponent } from './tenant/tenant-config-page.component';
import { TenantCustomerListPageComponent } from './tenant/tenant-customer-list-page.component';
import { TenantEmployeeComponent } from './tenant/tenant-employee/tenant-employee.component';
import { TenantIpRangePageComponent } from './tenant/tenant-ip-range-page.component';
import { TenantServicenumberPageComponent } from './tenant/tenant-servicenumber-page.component';
import { TenantThirdPartyServicePageComponent } from './tenant/tenant-third-party-service-page.component';
import { ThemeItemComponent } from './theme/item/theme-item.component';
import { ThemeListComponent } from './theme/list/theme-list.component';
import { ToolsComponent } from './tools/tools.component';

export const routes: Routes = [
  {
    path: 'payment-result',
    component: OrderPaymentResultComponent,
    canActivate: [AuthGuard],
    data: {
      title: '支付结果'
    }
  },
  {
    path: '',
    component: LayoutBasicComponent,
    canActivate: [AuthGuard],
    data: {},
    children: [
      {
        path: '',
        canActivate: [DashboardGuard],
        component: DashboardComponent,
        title: '總覽',
        data: {
          titleI18n: 'route.overview'
        }
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: '總覽',
          titleI18n: 'route.overview'
        }
      },
      {
        path: 'tools',
        component: ToolsComponent,
        data: { title: '工具' }
      },
      {
        path: 'liteconsole-login-authorization',
        component: LiteConsoleLoginAuthorizationComponent,
        data: { title: 'LiteConsole 登录授权' }
      },
      {
        path: 'socketio-connection-audit',
        component: SocketioConnectionAuditComponent,
        data: {
          title: 'Socket.IO 连接审计',
          titleI18n: 'route.socketio-connection-audit'
        }
      },
      {
        path: 'online-users',
        component: OnlineUsersComponent,
        data: {
          title: '在线用户',
          titleI18n: 'route.socketio-online-users'
        }
      },
      {
        path: 'point-activity-center',
        loadComponent: () => import('./point-activity-center/point-activity-center.component').then(m => m.PointActivityCenterComponent),
        data: {
          title: '点数活动',
          titleI18n: 'route.point-activity-center'
        }
      },
      {
        path: 'official-third-party-apps',
        component: OfficialThirdPartyAppsComponent,
        data: {
          title: '第三方应用',
          titleI18n: 'menu.official-third-party-apps'
        }
      },
      {
        path: 'official-assistant-store',
        component: OfficialAssistantStoreComponent,
        data: {
          title: '助手商店管理',
          titleI18n: 'menu.assistant-store-management'
        }
      },
      {
        path: 'scheduled-tasks',
        component: ScheduledTaskManagementComponent,
        data: {
          title: '定時任務管理',
          titleI18n: 'menu.scheduled-tasks'
        }
      },
      { path: 'tenant-dashboard', component: TenantDashboardComponent, data: { title: '總覽', titleI18n: 'route.overview' } },
      {
        path: 'tenants',
        children: [{ path: '', component: TenantListComponent }],
        data: {
          title: '租戶清單',
          titleI18n: 'route.tenant-list'
        }
      },
      {
        path: 'accounts',
        component: AccountListComponent,
        data: {
          title: '账号列表',
          titleI18n: 'route.account-list'
        }
      },
      {
        path: 'logs',
        children: [{ path: '', component: LogListComponent }],
        data: {
          title: '日誌列表',
          titleI18n: 'route.log-list'
        }
      },
      {
        path: 'team-certification-audit',
        component: TeamCertificationAuditComponent,
        data: {
          title: '團隊認證審核',
          titleI18n: 'route.team-certification-audit'
        }
      },
      {
        path: 'account',
        loadChildren: () => import('./account/routes').then(m => m.routes),
        data: {
          title: '帳號管理',
          titleI18n: 'route.account-management'
        }
      },
      {
        path: 'tenant/detail/:id',
        children: [{ path: '', component: TenantDetailComponent }],
        data: {
          title: '租户详情',
          titleI18n: 'route.tenant-detail'
        }
      },
      {
        path: 'tenants/detail/:id',
        children: [{ path: '', component: TenantDetailComponent }],
        data: {
          title: '租户详情',
          titleI18n: 'route.tenant-detail'
        }
      },
      {
        path: 'personal-tenant/:id',
        children: [
          {
            path: '',
            component: PersonalTenantComponent,
            canDeactivate: [CanDeactivateGuard]
          }
        ],
        data: {
          title: '基本資料'
        }
      },
      {
        path: 'personal-channel/:id',
        children: [
          {
            path: '',
            component: PersonalChannelComponent
          }
        ],
        data: {
          title: '社群通訊串接'
        }
      },
      {
        path: 'personal-service-setting/:id',
        children: [
          {
            path: '',
            component: PersonalServiceSettingComponent,
            canDeactivate: [CanDeactivateGuard]
          }
        ],
        data: {
          title: '服務設置'
        }
      },
      {
        path: 'personal-robot-setting/:id',
        children: [
          {
            path: '',
            component: PersonalRobotSettingComponent,
            canDeactivate: [CanDeactivateGuard]
          }
        ],
        data: {
          title: '分身设置',
          titleI18n: 'servicenumber.robot.personal.title'
        }
      },
      {
        path: 'official-robot-management/:id',
        children: [
          {
            path: '',
            component: RobotServiceListComponent
          }
        ],
        data: {
          title: '机器人管理'
        }
      },
      {
        path: 'personal-webchat-setting/:id',
        children: [
          {
            path: '',
            component: PersonalWebchatSettingComponent
          }
        ],
        data: {
          title: 'WebChat 設置',
          titleI18n: 'servicenumber.webchat.title'
        }
      },
      {
        path: 'personal-inbound-reason/:id/create',
        children: [
          {
            path: '',
            component: PersonalInboundReasonCreateComponent
          }
        ],
        data: {
          title: '新增來源',
          titleI18n: 'servicenumber.inbound-reason.create.title'
        }
      },
      {
        path: 'personal-inbound-reason/:id',
        children: [
          {
            path: '',
            component: PersonalInboundReasonComponent
          }
        ],
        data: {
          title: '進線原因管理',
          titleI18n: 'servicenumber.inbound-reason.title'
        }
      },
      {
        path: 'personal-assistant-management/:id',
        children: [
          {
            path: '',
            component: PersonalAssistantManagementComponent
          }
        ],
        data: {
          title: '助手管理',
          titleI18n: 'menu.assistant-management'
        }
      },
      {
        path: 'personal-broadcast-list/:id',
        children: [
          {
            path: '',
            component: PersonalBroadcastListComponent
          }
        ],
        data: {
          title: '群发消息'
        }
      },
      {
        path: 'personal-broadcast-detail/:id',
        children: [
          {
            path: '',
            component: PersonalBroadcastDetailComponent
          }
        ],
        data: {
          title: '新建群发'
        }
      },
      {
        path: 'personal-broadcast-detail/:id/:taskId',
        children: [
          {
            path: '',
            component: PersonalBroadcastDetailComponent
          }
        ],
        data: {
          title: '群发详情'
        }
      },
      {
        path: 'robot-service/config/:id',
        children: [
          {
            path: '',
            component: RobotServiceConfigComponent,
            canDeactivate: [CanDeactivateGuard]
          }
        ],
        data: {
          title: '機器人配置',
          titleI18n: 'robot-service.config.title'
        }
      },
      {
        path: 'personal-business-card/:id',
        children: [
          {
            path: '',
            component: PersonalBusinessCardSettingComponent
          }
        ],
        data: {
          title: '電子名片設定',
          titleI18n: 'servicenumber.business-card.title'
        }
      },
      {
        path: 'servicenumber-config',
        children: [
          {
            path: '',
            component: ServiceConfigComponent
          }
        ],
        data: {
          title: '服務設置'
        }
      },
      {
        path: 'system/config',
        children: [{ path: '', component: SystemConfigComponent }],
        data: {
          title: '系統設定'
        }
      },
      {
        path: 'reports',
        children: [{ path: '', component: ReportListComponent }],
        data: {
          title: '檢舉列表'
        }
      },
      {
        path: 'repairs',
        children: [{ path: '', component: IssueRepairListComponent }],
        data: {
          title: '問題報修'
        }
      },
      {
        path: 'quota-view',
        children: [{ path: '', component: QuotaViewComponent }],
        data: {
          title: '我的配額',
          titleI18n: 'route.quota-view'
        }
      },
      {
        path: 'quota-templates',
        pathMatch: 'full',
        redirectTo: 'quota-plans'
      },
      {
        path: 'quota-templates/:scopeType/:planId/:itemId',
        children: [{ path: '', component: QuotaTemplateComponent }],
        data: {
          title: '统一配额中心',
          titleI18n: 'route.quota-templates'
        }
      },
      {
        path: 'quota-plans',
        children: [{ path: '', component: QuotaPlanComponent }],
        data: {
          title: '统一配额中心',
          titleI18n: 'route.quota-templates'
        }
      },
      {
        path: 'pricing-packages',
        children: [{ path: '', component: PricingPackageCenterComponent }],
        data: {
          title: '功能套餐中心',
          titleI18n: 'route.pricing-package-center'
        }
      },
      {
        path: 'point-audit-center',
        children: [{ path: '', component: PointAuditCenterComponent }],
        data: {
          title: '点数审计',
          titleI18n: 'route.point-audit-center'
        }
      },
      {
        path: 'themes',
        children: [{ path: '', component: ThemeListComponent }],
        data: {
          title: '主題列表'
        }
      },
      {
        path: 'systemapps',
        children: [{ path: '', component: SystemappListComponent }],
        data: {
          title: '系统应用列表',
          titleI18n: 'route.systemapp-list'
        }
      },
      {
        path: 'themes/item',
        children: [{ path: '', component: ThemeItemComponent }],
        data: {
          title: '主題詳情'
        }
      },
      {
        path: 'themes/item/:id',
        children: [{ path: '', component: ThemeItemComponent }],
        data: {
          title: '主題詳情'
        }
      },
      {
        path: 'repairs/detail/:id',
        children: [{ path: '', component: IssueRepairDetailComponent }],
        data: {
          title: '問題詳情'
        }
      },
      {
        path: 'versions',
        loadChildren: () => import('./version-control/routes').then(m => m.routes),
        data: {
          title: '版本管控'
        }
      },
      {
        path: 'tenant/basic-info/:tenantId',
        children: [{ path: '', component: TenantBasicInfoPageComponent }],
        data: {
          title: '基本資料',
          titleI18n: 'menu.basic-info'
        }
      },
      {
        path: 'tenant/service-number-management/:tenantId',
        component: TenantServicenumberPageComponent,
        children: [
          {
            path: 'detail/:id',
            loadComponent: () => import('./servicenumber/detail/servicenumber-detail.component').then(m => m.ServicenumberDetailComponent),
            data: {
              title: '服務號詳情',
              titleI18n: 'servicenumber.detail.page-title'
            }
          },
          {
            path: 'detail',
            loadComponent: () => import('./servicenumber/detail/servicenumber-detail.component').then(m => m.ServicenumberDetailComponent),
            data: {
              title: '服務號詳情',
              titleI18n: 'servicenumber.detail.page-title'
            }
          }
        ],
        data: {
          title: '服務號管理',
          titleI18n: 'menu.servicenumber-management'
        }
      },
      {
        path: 'tenant/configuration/:tenantId',
        children: [{ path: '', component: TenantConfigPageComponent }],
        data: {
          title: '租戶配置',
          titleI18n: 'tenant.detail.tenant-config'
        }
      },
      {
        path: 'tenant/third-party-service/:tenantId',
        children: [{ path: '', component: TenantThirdPartyServicePageComponent }],
        data: {
          title: '第三方服務端',
          titleI18n: 'menu.third-party-service'
        }
      },
      {
        path: 'tenant/channel-binding/:tenantId',
        children: [{ path: '', component: TenantConfigPageComponent }],
        data: {
          title: '渠道綁定參數',
          titleI18n: 'tenant.detail.channel-binding-parameters'
        }
      },
      {
        path: 'tenant/application-list/:tenantId',
        children: [{ path: '', component: TenantApplicationListPageComponent }],
        data: {
          title: '應用列表',
          titleI18n: 'tenant.detail.application-list'
        }
      },
      {
        path: 'tenant/customer-list/:tenantId',
        children: [{ path: '', component: TenantCustomerListPageComponent }],
        data: {
          title: '客戶列表',
          titleI18n: 'tenant.detail.contacts'
        }
      },
      {
        path: 'tenant/team-management/:tenantId',
        children: [{ path: '', component: TenantEmployeeComponent }],
        data: {
          title: '團隊管理'
        }
      },
      {
        path: 'tenant/ip-range/:tenantId',
        children: [{ path: '', component: TenantIpRangePageComponent }],
        data: {
          title: 'IP 範圍管理',
          titleI18n: 'tenant.employee.tab.ip-range'
        }
      },
      {
        path: 'tenant/group-management/:tenantId',
        loadComponent: () => import('./tenant/group-management/group-management.component').then(m => m.GroupManagementComponent),
        data: {
          title: '社團管理',
          titleI18n: 'menu.group-management'
        }
      },
      {
        path: 'tenant/group-management/:tenantId/:roomId/members',
        loadComponent: () =>
          import('./tenant/group-management/group-member-management/group-member-management.component').then(
            m => m.GroupMemberManagementComponent
          ),
        data: {
          title: '社團成員管理',
          titleI18n: 'group.member.management'
        }
      },
      {
        path: 'tenant/authentication/:id',
        children: [{ path: '', component: TenantAuthenticationComponent }],
        data: {
          title: '认证資訊',
          titleI18n: 'tenant.certification.title'
        }
      }
    ]
  },
  {
    path: 'logs/detail/:id',
    component: LogDetailComponent,
    canActivate: [AuthGuard], // 使用新的全局守卫
    data: {
      title: '日志详情'
    }
  },
  {
    path: 'checkFBLogin',
    component: FacebookCallbackComponent,
    data: {
      title: '串接Facebook專頁'
    }
  },
  {
    path: 'checkIGLogin',
    component: InstagramCallbackComponent,
    data: {
      title: '串接Instagram專頁'
    }
  },
  {
    path: 'robot-service/config-flat/:id',
    component: RobotServiceConfigComponent,
    canActivate: [AuthGuard],
    data: {
      title: '機器人配置',
      titleI18n: 'robot-service.config.title'
    }
  },
  // passport 路由不需要认证守卫
  { path: '', loadChildren: () => import('./passport/routes').then(m => m.routes) },
  { path: 'exception', loadChildren: () => import('./exception/routes').then(m => m.routes) },
  {
    path: 'servicenumber',
    loadChildren: () => import('./servicenumber/routes').then(m => m.routes),
    data: { title: '服务号管理', titleI18n: 'route.servicenumber-management' }
  },
  { path: '**', redirectTo: 'exception/404' }
];
